require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./mobility-fairs-2-5-1-3.json") })
        }
      }, "path---mobility-fairs-2-5-1-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---mobility-fairs-2-5-1-3!./.cache/json/mobility-fairs-2-5-1-3.json
// module id = 503
// module chunks = 231608221292675